import { ActionBar, Card, Grid, GridRow } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../../../components/Page/Page';
import { TimetableBlocksYearOverview } from '../../../../components/TimetableBlock/components/TimetableBlocksYearOverview';
import { TimetableBlockFactorModal } from '../../../../components/TimetableBlock/modals/TimetableBlockFactorModal';
import { TimetableBlockTable } from '../../../../components/TimetableBlock/tables/TimetableBlockTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { useSelectedSchoolYear } from '../../../../hooks/useSelectedSchoolYear';

export const DeputateAnnualPage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const schoolYear = useSelectedSchoolYear();
  const permissions = usePermissionChecker();

  const [searchString, setSearchString] = useState<string | null>(null);
  const [blockUuid, setBlockUuid] = useState<string | null>(null);
  const [proportionModalOpen, setProportionModalOpen] = useState<boolean>(false);

  function handleEvaluate(uuid: string | null) {
    if (uuid) {
      navigate(uuid);
    } else {
      navigate(t('routes.deputate.evaluate.all.slug'));
    }
  }

  function handleEdit(uuid: string) {
    setBlockUuid(uuid);
    setProportionModalOpen(true);
  }

  function handleClose() {
    setProportionModalOpen(false);
    setBlockUuid(null);
  }

  return (
    <Page isForbidden={!permissions?.canReadDeputate()} title={t('deputate.annual')}>
      <Grid>
        <GridRow>
          <ActionBar marginBottom='0' onGlobalFilterChange={setSearchString} />
        </GridRow>
        <GridRow spacingTop='s' spacingBottom='s'>
          <Card
            header={{
              headline: `${t('common.all')} ${t('timetableBlock.title', {
                count: 2,
              })}`,
              actions: [
                {
                  text: t('common.evaluate'),
                  callback: () => handleEvaluate(null),
                  hierarchy: 'secondary',
                },
              ],
              subHeadline: schoolYear?.name,
              showSubHeadlineAsChip: true,
            }}
          >
            <div className='mt-2'>
              <TimetableBlocksYearOverview />
            </div>
          </Card>
        </GridRow>
        <GridRow>
          <TimetableBlockTable
            searchString={searchString}
            onEvaluate={handleEvaluate}
            onEdit={handleEdit}
            readonly={!permissions?.canWriteDeputate()}
          />
        </GridRow>
      </Grid>

      {blockUuid && (
        <TimetableBlockFactorModal timetableBlockUuid={blockUuid} isOpen={proportionModalOpen} onClose={handleClose} />
      )}
    </Page>
  );
});
